import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
//import Footer from 'examples/Footer';
import Footer from "layouts/authentication/components/Footer";
import SoftButton from 'components/SoftButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Pricing page components
import FaqCollapse from "layouts/pages/pricing-page/components/FaqCollapse";



const FAQPage = () => {
  const [collapse, setCollapse] = useState(false);
  const faqs = [
   {
    question: 'How do I reset my password?',
    answer: 'To reset your password, please navigate to the "Account Settings" page within our app. There, you\'ll find the option to reset your password. Note that if you\'ve signed up using third-party providers like Google, you\'ll need to follow their procedures to reset your password.'
   },
   {
     question: 'What AI models do we use?',
     answer: 'We use Deepgram for our transcription services, which is renowned for its state-of-the-art speech-to-text capabilities and it\s leading position in the market. For our summarizations, we utilize the cutting-edge GPT models to ensure high-quality and accurate results. Note: Recently Antrophic (one of GPT\s main competitors) did release a better and more accurate model, ofcourse we are planning to switch to this provider as soon as we are fully HIPAA compliant with them. At least until Openai publishes an even better model (GPT-5) ;)'
   },
   {
     question: 'Is my personal data and the data of my patients protected?',
     answer: 'Absolutely. Our application adheres to HIPAA and GDPR standards, ensuring that your data, as well as your patients\' data, is secured both in rest and at transit. Access is strictly limited to authorized users, guaranteeing the privacy and confidentiality of your information.'
   },
   {
     question: 'Can I customize my summarization templates?',
     answer: 'Yes, you can. Based on the profession you select during account setup, we provide a range of summarization templates crafted with input from real-world experts. You are free to customize, add, or delete prompts, and there\'s no limit to the number of prompts you can have.'
   },
   {
     question: 'I need help writing my own summarization notes/prompts.',
     answer: 'Our AI assistant is ready to help you. Accessible via the chat icon at the bottom right of our app, the assistant will guide you in crafting optimized prompts to ensure our AI models can effectively meet your summarization needs.'
   },
   {
     question: 'Do I need a microphone?',
     answer: 'There\'s no special equipment required. Our voice recording feature is designed to work seamlessly with the built-in microphone on your desktop, mobile device, or tablet, ensuring accurate and clear recordings.'
   },
   {
     question: 'How and where are my files stored?',
     answer: 'All transcripts and summarizations are saved automatically and are associated with the respective visit/session for a patient. These records can be accessed in the Database page of our app, where each patient has a dedicated record that includes all visits/sessions, each timestamped for your convenience.'
   },
   {
     question: 'Do I need to do/write anything myself?',
     answer: 'Not at all. Simply converse with your patient as you normally would, and our app handles the transcription and summarization. It\'s designed to save you time and effort, allowing you to focus on your patient.'
   },
   {
    question: 'How does your pricing compare to competitors?',
    answer: 'Optimind-AI stands out not just for our affordability but also for our unparalleled value. As the leading dictation and summarization software for healthcare providers, we offer the most features, highest accuracies, and exceptional customizability—all at a price point that is significantly lower than our competitors. With Optimind-AI, you receive more recording hours, more summarizations, and access to state-of-the-art AI models, all wrapped in the best-designed interface in the market. Our commitment to safety, customization, and innovation makes us not just cheaper, but the most cost-effective solution available.And for a little extra insight: feel free to take all the free trials you can handle. We’re confident that, like a fine wine compared to grape juice, you’ll see (and taste) the difference with Optimind-AI. Cheers to making the informed choice!',
    }
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
        <SoftBox mt={10}>
          <Grid container justifyContent="center">
            <Grid item xs={12} md={6} mb={5}>
              <SoftTypography variant="h2" align="center" fontWeight="bold" gutterBottom>
                Frequently Asked Questions
              </SoftTypography>
              <SoftBox mb={2}>
                <SoftTypography variant="body2" align="center" color="text">
                  You can always ask your questions to our dedicated AI assistant.
                </SoftTypography>
              </SoftBox>
            </Grid>
            <Grid item xs={12} md={10}>
              {faqs.map((faq, index) => (
                <FaqCollapse
                  key={index}
                  title={faq.question}
                  open={collapse === index + 1}
                  onClick={() => (collapse === index + 1 ? setCollapse(false) : setCollapse(index + 1))}
                >
                  {faq.answer}
                </FaqCollapse>
              ))}
            </Grid>
          </Grid>
        </SoftBox>
      <Footer />
    </DashboardLayout>
  );
};

export default FAQPage;
